<script context="module">
  export const notices = {};
</script>

<script>
  export let position = 'top';

  let container;
  let positionClass;
  $: positionClass = position === 'top' ? 'is-top' : 'is-bottom';

  export function insert(el) {
    container.insertAdjacentElement('afterbegin', el);
  }
</script>

<style>
  .notices {
    position: fixed;
    top: 10px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    padding: 3em;
    z-index: 10000099;
    pointer-events: none;
    display: flex;
    flex-direction: column;
  }
</style>

<div class="notices {positionClass}" bind:this={container} />
